import { bool, func } from 'prop-types';
import Modal from '../../shared/Modal';
import Button from '../../shared/Button';
import { Box, Stack, Flex } from '../../shared/layouts';
import ConfirmIcon from 'imagesUwKluis/svg/confirmfill.svg';
import {useTranslation} from "react-i18next";

const TwoFactorAuthCompletedModal = ({
  isOpen,
  onRequestClose,
  onBtnClick,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      minWidth="554px"
      showCloseButton={false}
      showProgressBar
      progressBarValue={4}
      progressBarTotal={6}
    >
      <Stack space="l">
        <Flex alignItems="center" flexDirection="column">
          <ConfirmIcon
            width="130px"
            height="130px"
            css={(theme) => ({
              fill: theme?.colors?.primary || 'blue',
              display: 'block',
              margin: '40px 0 25px',
            })}
          />
          <Box fontScale="xl" fontWeight="bold" marginBottom="15px">
            {t('Koppeling geslaagd!')}
          </Box>
          <Box textAlign="center" marginBottom="15px">
            {t('Je authenticatie-app is nu gekoppeld aan je account. Voortaan vragen we je om een extra code als je wilt inloggen. Wel zo veilig!')}
          </Box>
        </Flex>
      </Stack>
      <Flex justifyContent="flex-end" mt="80px">
        <Button onClick={onBtnClick}>{t('Verder')}</Button>
      </Flex>
    </Modal>
  );
}

TwoFactorAuthCompletedModal.propTypes = {
  isOpen: bool,
  onRequestClose: func,
  onBtnClick: func,
};

TwoFactorAuthCompletedModal.defaultProps = {
  isOpen: false,
  onRequestClose: () => {},
  onBtnClick: () => {},
};

export default TwoFactorAuthCompletedModal;
